
<div class="pipeline-filter-separator" :width="width" />
